import { render, staticRenderFns } from "./SentimentPopularCompare.vue?vue&type=template&id=257587c7&scoped=true"
import script from "./SentimentPopularCompare.vue?vue&type=script&lang=js"
export * from "./SentimentPopularCompare.vue?vue&type=script&lang=js"
import style0 from "./SentimentPopularCompare.vue?vue&type=style&index=0&id=257587c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257587c7",
  null
  
)

export default component.exports